export default "__VITE_ASSET__b7f4f096__"